import React, { useEffect }  from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classnames from 'classnames/bind';
import * as amplitude from '@amplitude/analytics-browser';

import styles from './home.scss';
let cx = classnames.bind(styles);

const Home = ({ locale, translations }) => {
    const navigate = useNavigate();

    useEffect(() => {
        // Prevent scrolling on mobile
        document.ontouchmove = function (e) {
            if (e.changedTouches.length > 1)
                e.preventDefault();
        }
         // Prevent zoom on mobile
        document.addEventListener('gesturestart', function (e) {
            e.preventDefault();
        });

        var appStoreButton = document.getElementById('app-store-button');
        appStoreButton.addEventListener('touchstart', handleAppStoreButtonTouchStart);
        appStoreButton.addEventListener('touchend', handleAppStoreButtonTouchEnd);
        appStoreButton.addEventListener('click', handleAppStoreButtonClick);

        var googlePlayButton = document.getElementById('google-play-button');
        googlePlayButton.addEventListener('touchstart', handleGooglePlayButtonTouchStart);
        googlePlayButton.addEventListener('touchend', handleGooglePlayButtonTouchEnd);
        googlePlayButton.addEventListener('click', handleGooglePlayButtonClick);
    }, []);

    const handleAppStoreButtonTouchStart = e => {
        e.returnValue = false;

        var button = document.getElementById('app-store-button');
        button.style.pointerEvents = 'none';
    }

    const handleAppStoreButtonTouchEnd = e => {
        e.returnValue = false;

        var button = document.getElementById('app-store-button');
        button.style.pointerEvents = 'auto';

        window.open('https://apps.apple.com/app/id6476118402', '_blank');

        handleAppStoreAnalytics();
    }

    const handleAppStoreButtonClick = e => {
        let isTouchDevice = ('ontouchstart' in document.documentElement);

        if (!isTouchDevice) {
            handleAppStoreAnalytics();
        }
    }

    const handleAppStoreAnalytics = () => {
        amplitude.track('website_app_store_button');
    }

    const handleGooglePlayButtonTouchStart = e => {
        e.returnValue = false;

        var button = document.getElementById('google-play-button');
        button.style.pointerEvents = 'none';
    }

    const handleGooglePlayButtonTouchEnd = e => {
        e.returnValue = false;

        var button = document.getElementById('google-play-button');
        button.style.pointerEvents = 'auto';

        console.log(`/${locale}/android`);

        navigate(`/${locale}/android`);
        handleGooglePlayAnalytics();
    }

    const handleGooglePlayButtonClick = e => {
        let isTouchDevice = ('ontouchstart' in document.documentElement);

        if (!isTouchDevice) {
            handleGooglePlayAnalytics();
        }
    }

    const handleGooglePlayAnalytics = () => {
        amplitude.track('website_google_play_button');
    }

    return (
        <main className={cx('home', 'flex', 'column', 'justify-content-center', 'align-items-center')}>
            <h1 className={cx('logo')}>
                PNK
            </h1>
            <h2 className={cx('title')}>
                {translations['HOME_DESCRIPTION_FIRST']} <br />{translations['HOME_DESCRIPTION_LAST']}
            </h2>
            <br /><br /><br />
            <h2 className={cx('subtitle')}>
                {translations['HOME_DOWNLOAD_APP']}
            </h2>
            <br />
            <Link to="https://apps.apple.com/app/id6476118402" target="_blank" className={cx('flex', 'align-items-center', 'justify-content-center', 'download-button')} id="app-store-button">
                <svg className={cx('icon')} width="22" height="28" viewBox="0 0 22 28" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M10.9623 6.32678C10.9623 6.32678 10.5589 4.54922 12.137 2.47024C13.9101 0.134148 16.3748 0.12085 16.3748 0.12085C16.3748 0.12085 16.7427 2.31952 14.9784 4.43397C13.0989 6.69913 10.9623 6.32678 10.9623 6.32678ZM18.3607 14.4255C18.3607 10.8039 21.2775 9.31449 21.2775 9.31449C21.2775 9.31449 19.7836 6.61491 15.9936 6.61491C13.7905 6.61491 12.0971 7.86939 11.184 7.86939C10.1201 7.86939 8.53758 6.69027 6.48962 6.69027C3.3512 6.69027 0 9.5051 0 14.8688C0 20.3211 3.95849 27.1078 7.09248 27.1078C8.18739 27.1078 9.86742 26.004 11.5608 26.004C13.2231 26.004 14.4465 27.0679 16.0246 27.0679C19.4556 27.0679 22 19.9133 22 19.9133C22 19.9133 18.3607 18.5081 18.3607 14.4255Z"></path></svg>
                <span>APP STORE</span>
            </Link>
            <br />
            <Link to="https://play.google.com/store/apps/details?id=app.pnk" className={cx('flex', 'align-items-center', 'justify-content-center', 'download-button')} id="google-play-button">
                <svg className={cx('icon')} width="28" height="28" viewBox="4 4 28 28" xmlns="http://www.w3.org/2000/svg"><path d="M10.09,8a1.94,1.94,0,0,1,1.28.28l13,7.39L21.08,19Zm-1,1A2.31,2.31,0,0,0,9,9.67V30.33a2.31,2.31,0,0,0,.09.67l11-11Zm12,12-11,11a1.88,1.88,0,0,0,1.28-.28l13-7.39Zm8.52-2.34-3.94-2.24L22.07,20l3.59,3.59,3.94-2.24C30.9,20.61,30.9,19.39,29.6,18.65Z"/></svg>
                <span>GOOGLE PLAY</span>
            </Link>
        </main>
    );
};

export default Home;
